import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-02747605"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-container py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["navbar-item", { 'active-link': _ctx.isActiveRoute('Dashboard') }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('Dashboard')))
    }, [
      _createVNode(_component_v_icon, { icon: "mdi-view-dashboard-variant" }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('i18n.dashboard')), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["navbar-item", { 'active-link': _ctx.isActiveRoute('Devices') }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('Devices')))
    }, [
      _createVNode(_component_v_icon, { icon: "mdi-tablet-cellphone" }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('i18n.devices')), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["navbar-item", { 'active-link': _ctx.isActiveRoute('Forms') || _ctx.isActiveRoute('CreateForm') || _ctx.isActiveRoute('EditForm') }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('Forms')))
    }, [
      _createVNode(_component_v_icon, { icon: "mdi-list-box-outline" }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('i18n.forms')), 1)
    ], 2)
  ]))
}